tinymce.PluginManager.add('insertLink', function (editor, url) {
    editor.ui.registry.addIcon(
        "link-icon",
        `<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont"><mask id="dvyyvpy5a__nx13k4jsoa" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path fill="#D9D9D9" d="M0 0H24V24H0z"/></mask><g mask="url(#dvyyvpy5a__nx13k4jsoa)" fill-rule="evenodd" clip-rule="evenodd" fill="#333"><path d="M12 4.57541C14.0503 2.52515 17.3744 2.52516 19.4246 4.57541C21.4749 6.62566 21.4749 9.94978 19.4246 12L18.364 13.0607C18.0711 13.3536 17.5962 13.3536 17.3033 13.0607C17.0104 12.7678 17.0104 12.2929 17.3033 12L18.364 10.9394C19.8284 9.4749 19.8284 7.10053 18.364 5.63607C16.8995 4.1716 14.5251 4.1716 13.0607 5.63607L11.4697 7.22706C10.1856 8.5111 10.0274 10.4947 10.9951 11.9511C11.2243 12.2961 11.2322 12.7678 10.9393 13.0607C10.6464 13.3536 10.1662 13.3562 9.91762 13.0249C8.37447 10.9684 8.53827 8.03714 10.409 6.1664L12 4.57541Z"/><path d="M12 19.4246C9.94975 21.4748 6.62563 21.4748 4.57538 19.4246C2.52513 17.3743 2.52513 14.0502 4.57538 12L6.16637 10.409C6.45926 10.1161 6.93414 10.1161 7.22703 10.409C7.51992 10.7019 7.51992 11.1767 7.22703 11.4696L5.63604 13.0606C4.17157 14.5251 4.17157 16.8995 5.63604 18.3639C7.1005 19.8284 9.47487 19.8284 10.9393 18.3639L12.7425 16.5608C13.9091 15.3942 14.0655 13.6 13.2119 12.2651C12.9888 11.9161 12.9799 11.4443 13.2728 11.1514C13.5657 10.8585 14.0462 10.8557 14.2919 11.1892C15.7195 13.1263 15.5566 15.868 13.8031 17.6215L12 19.4246Z"/></g></svg>`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('insertLink', {
        icon: `link-icon`,
        tooltip: '插入超链接',
        onAction: function () {
            window.postMessage("openInsertLink", "*");
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});